// @flow

import type {AnchorPosition, BoxPosition, CoordinatesType, CoordinatesBox} from './typedef';


type GetCoordinatesBox = ({|
    isAbsolute: boolean,
    isNeedScrollOffset: boolean,
    anchorRect: ClientRect | CoordinatesType,
    anchorOffset: AnchorPosition,
    elemTransformOrigin: BoxPosition,
|}) => CoordinatesBox;

/**
* A utility that checks the coordinates of a point in the DOM.
* @namespace
* @property {object} param - The default values for configuration parameter.
* @property {boolean} param.isAbsolute - Do you need to consider absolute positions.
* @property {boolean} param.isNeedScrollOffset - This is the point on the anchor.
* @property {ClientRect | CoordinatesType} param.anchorRect - This is the point on the anchor.
* @property {AnchorPosition} param.anchorOffset - Specifies how close to the edge of the anchor the Box can appear.
* @property {BoxPosition} param.elemTransformOrigin - The component used for the transition.
* @returns {CoordinatesBox}
 @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*/
export const getCoordinatesBox: GetCoordinatesBox = param => {
    const {isAbsolute, anchorRect, anchorOffset, elemTransformOrigin, isNeedScrollOffset} = param;

    if (isAbsolute) {
        const pageYOffset = isNeedScrollOffset ? window.pageYOffset : 0;
        const pageXOffset = isNeedScrollOffset ? window.pageXOffset : 0;

        return {
            top: anchorRect.top + anchorOffset.top - elemTransformOrigin.vertical + pageYOffset,
            left: anchorRect.left + anchorOffset.left - elemTransformOrigin.horizontal + pageXOffset
        };
    } else {
        return {
            top: anchorOffset.top - elemTransformOrigin.vertical,
            left: anchorOffset.left - elemTransformOrigin.horizontal
        };
    }
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
